import { c as _c } from "react/compiler-runtime";
import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
interface SingleWaveDropCloseProps {
  readonly onClose: () => void;
}
export const SingleWaveDropClose: React.FC<SingleWaveDropCloseProps> = t0 => {
  const $ = _c(3);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <XMarkIcon aria-hidden="true" className="tw-h-6 tw-w-6 tw-flex-shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <button type="button" className="tw-absolute tw-z-1000 tw-top-[calc(env(safe-area-inset-top,0px)+0.5rem)] tw-right-4 lg:tw-top-0 tw-text-iron-300 desktop-hover:hover:tw-text-iron-400 tw-bg-transparent tw-border-0 tw-transition tw-duration-300 tw-ease-out" onClick={onClose}>{t1}</button>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};